<div class="media-library-skeleton" [class.media-library-skeleton--page]="pageMode">
  <div class="media-library-skeleton__grid" [class.row]="!pageMode">
    <div class="media-library-skeleton__item" [ngClass]="pageMode ? '' : 'col-6 col-sm-4 col-md-3 col-xl-2 mb-3'" *ngFor="let i of skeletonItems">
      <app-skeleton-rect width="100%" height="100%" [borderRadius]="'0'" class="media-library-skeleton__thumb"></app-skeleton-rect>
      <div class="media-library-skeleton__info">
        <app-skeleton-rect width="80%" height="14px" class="d-block mb-2"></app-skeleton-rect>
        <app-skeleton-rect width="45%" height="12px" class="d-block"></app-skeleton-rect>
      </div>
    </div>
  </div>
</div>
